import { createMachine } from 'xstate';

import { createPayload, handleRefund, executeRefund } from './actions';

const refundMachine = createMachine(
  {
    id: 'verifone-refund',
    initial: 'idle',
    context: {
      config: null,
      request: null,
      response: null,
    },
    states: {
      idle: {
        on: {
          INITIALISE: 'loading',
        },
      },
      loading: {
        entry: ['createPayload'],
        invoke: {
          id: 'verifoneRequest',
          src: executeRefund,
          onDone: {
            target: 'success',
            actions: ['handleRefund'],
          },
          onError: {
            target: 'cancelled',
          },
        },
      },
      success: {
        type: 'final',
      },
      failure: {
        on: {
          RETRY: {
            target: 'loading',
          },
          CANCEL: {
            target: 'cancelled',
          },
        },
      },
      cancelled: {
        type: 'final',
      },
    },
  },
  {
    actions: {
      createPayload,
      executeRefund,
      handleRefund,
    },
  },
);

export { refundMachine };
